import { render, staticRenderFns } from "./FileImportLicenseTable.vue?vue&type=template&id=7f869d44&"
import script from "./FileImportLicenseTable.vue?vue&type=script&lang=js&"
export * from "./FileImportLicenseTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports